export enum DataChangeSource {
  QUESTIONNAIRE_RESPONSE = 'QUESTIONNAIRE_RESPONSE',
  DEVICE_SESSION = 'DEVICE_SESSION',
  DEVICE_OBSERVATION = 'DEVICE_OBSERVATION',
  USER = 'USER',
  UNKNOWN = 'UNKNOWN',
}
